import { Box, Theme, useMediaQuery } from '@mui/material';

import { PartnerBanks } from 'components/PartnerBanks/PartnerBanks';
import { TrustBanner } from 'components/TrustBanners/TrustBanner';
import { advantages } from 'legacy/data/advantages';
import Advantages from 'components/Advantages';
import CTAStepExplanations from 'components/CTAStepExplanations';
import { Divider } from 'components/Divider';
import BottomNavigationMap from 'components/BottomNavigation/BottomNavigationMap';

import { LegalTextGoogleFooter } from 'components/Stage/LegalText';
import { LegalTextGoogle } from 'components/Stage/LegalTextGoogle';
/*
 * This is placeholder component for pre packaged content for our SEA pages.
 */

export const PrePackagedSeaContent = () => {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('md'),
  );

  return (
    <>
      <PartnerBanks />
      {!isMobile && <LegalTextGoogle />}
      <TrustBanner title="Über 300.000 zufriedene Kunden seit 2007" />
      {/* @ts-ignore */}
      <Advantages {...advantages} />
      <CTAStepExplanations headline="So einfach geht's" />
      <LegalTextGoogleFooter />
      <Box pb={2}>
        <Divider />
      </Box>
      <BottomNavigationMap />
    </>
  );
};
